module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc21"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/005_Acknowledgement"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc21"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/006_Introduction"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 1")])]), _vm._v(" Growing up in the West Indies, 1903–1912")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 2")])]), _vm._v(" Antigua School Days, 1913–1916")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 3")])]), _vm._v(" Relocation to England, 1916–1920")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 4")])]), _vm._v(" The Antigua Sugar Factory and the Motor Boat "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Isa")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 5")])]), _vm._v(" Return to England and Entry into the RAF. Flying the Mono Avro 504K, 1923–1925")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 6")])]), _vm._v(" The Dangers of Anoxia, 1924")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 7")])]), _vm._v(" Problems with Navigation, 1925")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 8")])]), _vm._v(" 23 Squadron, Henlow: Night Exercises, 1925")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 9")])]), _vm._v(" Engineering at Henlow: a Smashed Propeller, 1927–1928")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 10")])]), _vm._v(" Cambridge University and Imperial College London, 1929–1932")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/017_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 11")])]), _vm._v(" The Singapore Experience, 1933–1935\t88")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/018_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 12")])]), _vm._v(" Water Sports at RAF Base Seletar and Return to England")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/019_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 13")])]), _vm._v(" Return to Competitive Sailing, 1936")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/020_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 14")])]), _vm._v(" Biggin Hill, 1936–1937")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/021_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 15")])]), _vm._v(" Andover Staff College and The Dowding Experiment, 1938")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/022_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 16")])]), _vm._v(" Outbreak of War, 1939")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/023_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 17")])]), _vm._v(" The Duxford Invisible Flight Path, 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/024_Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 18")])]), _vm._v(" Across Africa to Ceylon: The War in the Far East Against Japan, 1942–1943")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/025_Chapter_19",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 19")])]), _vm._v(" The War in the Far East Against Japan, 1943–1945. Air Officer for Training, India")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/026_Chapter_20",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 20")])]), _vm._v(" Photo Reconnaissance, 1945–1946")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/027_Chapter_21",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 21")])]), _vm._v(" The 1948 Olympic Games, Torquay")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/028_Chapter_22",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 22")])]), _vm._v(" Later Career, 1948–1962")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc21"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/029_Chapter_23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix I: The Battle of the Saintes, 1782")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc21"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/030_Chapter_24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix II: Ian Donald Roy McDonald Mc Dfc, Arthur’s First")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cousin and First World War Air Ace")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc21"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/031_Chapter_25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix III: The Prelude to the Biggin Hill Experiment, the men who made it possible: H.E. Wimperis, Tizard, Watson-Watt and")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Dowding")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc21"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/032_Chapter_26",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix IV: The Biggin Hill Experiment: Further background information written by Arthur")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc21"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/033_Chapter_27",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix V: The Battle Re-Thought: A Critique on the Symposium")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("on the Battle of Britain in 1990, by Arthur")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc21"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/034_Chapter_28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix VI: Background Information on Ceylon During the War and Documents Relating to Arthur’s Time in Ceylon and India")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc21"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/035_Chapter_29",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix VII: Table of Aircraft, compiled by Arthur’s Great")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Grandchild Joe Jameson")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc21"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/036_Chapter_30",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix VIII: Commander-in-Chief, Pakistan Air Force, 1955–1957")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc21"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/037_Chapter_31",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix IX: RAF Service History")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc21"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/038_Chapter_32",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix X: Address Made at the Celebration of Sir Arthur’s 90th Birthday, 16 June 1993")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc21"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/039_Chapter_33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix XI: Sailing Highlights in Retirement, Royal Lymington")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Yacht Club")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc21"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/040_Chapter_34",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0